import React from 'react';

interface ToastProps {
  id: string;
  title: string;
  description?: string;
  variant?: 'default' | 'destructive';
  onDismiss: (id: string) => void;
}

export function Toast({
  id,
  title,
  description,
  variant = 'default',
  onDismiss,
}: ToastProps) {
  const variants = {
    default: 'bg-white border-gray-200 text-gray-900',
    destructive: 'bg-red-50 border-red-200 text-red-900',
  };

  return (
    <div className={`rounded-lg border p-4 shadow-lg ${variants[variant]}`}>
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <div className="font-medium">{title}</div>
          {description && (
            <div className="text-sm opacity-90 mt-1">{description}</div>
          )}
        </div>
        <button
          onClick={() => onDismiss(id)}
          className="ml-4 text-gray-400 hover:text-gray-600"
        >
          ×
        </button>
      </div>
    </div>
  );
}
